import React from "react";
import PATH from "constants/path";
import { useDispatch, useSelector } from "react-redux";
import { clearApplyPromotion } from "features/Promotion/promotionSlice";
import { getTitleDecoration } from "utils/common";
import { useHistory } from "react-router";
import { illust05 } from "assets/img";

const ModalConfirm = ({ check, closeFn, open = false }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  // redux store
  const { promotion, promotion_set, list } = useSelector((state) => state.promotion);

  // redirect to ENTRIES SCREEN
  const handleConfirm = () => {
    closeFn();
    history.push(PATH.ENTRIES);
    dispatch(clearApplyPromotion());
  };

  /**
   * get list partner name of promotion set
   * @param id int
   */
   const getListName = (id) => {
    const list_partner_id = list.filter((item) =>
      item.promotion_set_id.includes("" + id)
    );
    if (list_partner_id.length > 0) {
      return list_partner_id
        .map((item) => item.last_name + " " + item.first_name)
        .join(", ");
    }
    return "なし";
  };

  return (
    open && (
      <div className="modal active fw-600">
        <div className="modal-body">
          <div className="fs-16 fs-sm-14 text-center mt-2 text-black">
            ご応募ありがとうございます
          </div>
          <div className="border-color-black border-radius-5px px-3 py-2 my-3 fs-14">
            {/* DECORATION */}
            <span
              className="me-1"
              dangerouslySetInnerHTML={{
                __html: getTitleDecoration(
                  promotion?.title_decoration?.title_decoration_content
                ),
              }}
            ></span>

            {/* TITLE */}
            {promotion?.title_login}
          </div>

          <div className="mt-2">
              {/* PROMOTION SET & PARTNER LIST */}
              {promotion_set.map((item) => {
                if (check.includes("" + item.id)) {
                  return (
                    <div key={item.id} className="my-2 fw-600 fs-13">
                      { promotion?.split_flg == 1 &&
                      <div className="bg-violet px-2 py-1 fs-sm-12 mb-sm-1-px">
                        {item.name}
                      </div>}
                      { promotion?.partner_flg == 1 &&
                      <div className="bg-pink px-2 py-1 py-1 fs-sm-9">
                        同行者：{getListName(item.id)}
                      </div>}
                    </div>
                  );
                }
              })}
          </div>

          {/* DESCRIPTION */}
          <div className="clearfix d-md-block">
            <div className="float-start me-3">
              <div className="modal-img">
                <img src={illust05} alt="illust05" />
              </div>
            </div>
            <div className="my-3 fw-600">
              ご応募いただいた案件は「応募中案件」ページに表示されます。「ステップ詳細」をクリックして、ステップに沿って案件を進めてください。
            </div>
            <div className="mt-3 mt-md-0 my-md-3 fw-600 text-red fs-sm-11 text-center">
              ※応募いただいた案件は、ステップの途中でもキャンセル可能です。
            </div>
          </div>

          {/* GROUP BUTTON */}
          <div className="text-center my-3">
            <div onClick={handleConfirm} className="btn-custom orange">
              応募中案件へ移動する
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalConfirm;
